<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col xl="12">
        <b-card no-header>
          <b-alert
            class= "alert"
            :show="dismissCountDown"
            dismissible
            fade
            :variant="alertVariant"
            @dismissed="dismissCountDown = 0"
            @dismiss-count-down="countDownChanged">
            <p>{{ alertMsj }}</p>
          </b-alert>             

          <b-form>
            <b-form-group
              label="Monto Mínimo"
              label-for="montoMinimo"
              :labelCols="labelCols"
              horizontal>
              <b-form-input 
                id="montoMinimo"
                :value="montoMinimo | moneda"
                type="text"
                readonly>
              </b-form-input>
            </b-form-group>

            <b-form-group
              label="Monto Máximo"
              label-for="montoMaximo"
              :labelCols="labelCols"
              horizontal>
              <b-input-group>
                <b-input-group-prepend is-text>
                  <b-form-checkbox 
                      id="limiteMaximoHabilitado"
                      v-model="limiteMaximoHabilitado"
                      :value="true"
                      :unchecked-value="false">
                  </b-form-checkbox>
                </b-input-group-prepend>
                <b-form-input 
                  id="montoMaximo"
                  v-model.trim="$v.montoMaximo.$model" 
                  :state="montoMaximoValido"
                  type="text"
                  :readonly="!limiteMaximoHabilitado"
                  @blur.native="validate">
                </b-form-input>
              </b-input-group>
              <b-form-invalid-feedback id="montoMaximoFeedback">
                {{ montoMaximoInvalidoMsj }}
              </b-form-invalid-feedback>          
            </b-form-group>


            <b-form-group
              label="Pje Financiación"
              label-for="pjeFinanciacion"
              :labelCols="labelCols"
              horizontal>
              <b-form-input 
                id="pjeFinanciacion"
                v-model.trim="$v.pjeFinanciacion.$model" 
                :state="pjeFinanciacionValido"
                type="text"
                @blur.native="validate">
              </b-form-input>
              <b-form-invalid-feedback id="pjeFinanciacionFeedback">
                {{ pjeFinanciacionInvalidoMsj }}
              </b-form-invalid-feedback>          
            </b-form-group>
          </b-form>

          <div slot="footer">
            <b-button size="sm" variant="primary" class="footer-button"
              @click.prevent="save">Grabar</b-button>
            <b-button size="sm" variant="danger" class="footer-button"
              @click.prevent="close">Cancelar</b-button>
          </div>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { required, decimal, minValue } from 'vuelidate/lib/validators';

export default {
  name: 'ClienteEscalaFinanciacion',
  components: {
  },
  props: {
    escalaFinanciacion: {
      type: Object,
      default: null
    },
    escalas: {
      type: Array,
      default: []
    }
  },
  data () {
    return {
      montoMinimo: 0,
      montoMaximo: 0,
      pjeFinanciacion: 0,

      noValidar: true,
      montoMaximoValido: null,
      montoMaximoInvalidoMsj: '',
      pjeFinanciacionValido: null,
      pjeFinanciacionInvalidoMsj: '',

      limiteMaximoHabilitado: true,

      labelCols: 3,
      alertCountDown: 15, 
      dismissCountDown: 0,
      alertVariant: 'danger',
      alertMsj: '',
    }
  },
  created() {
    if (this.escalaFinanciacion) {
      this.montoMinimo = parseFloat(this.escalaFinanciacion.montoMinimo);
      this.montoMaximo = parseFloat(this.escalaFinanciacion.montoMaximo);
      this.pjeFinanciacion = parseFloat(this.escalaFinanciacion.pjeFinanciacion);
      if (this.montoMaximo == 0) {
        this.limiteMaximoHabilitado = false;
      }
    }
  },  
  methods: {
    countDownChanged(dismissCountDown) {
      this.dismissCountDown = dismissCountDown;
    },
    showAlert(alertMsj, alertVariant) {
      this.alertMsj = alertMsj;
      this.alertVariant = alertVariant;
      this.dismissCountDown = this.alertCountDown;
    },
    validate(event) {
      if (event) {
        if (event.target) {
          /* Antes de intentar registrar por primera vez, no validamos */
          if (!this.noValidar)
          {
            this.$v.$touch();
            this.displayErrores(event.target.id);
          }

          if (event.target.id == 'montoMaximo') {
            this.calcularMontoMinimo();
          }
        }
      } 
    },
    displayErrores(field) {
      var validarTodos = false;
      var campo = '';

      if (field) {
        campo = field;
      } else {
        validarTodos = true;
      }

      if (campo == 'montoMaximo' || validarTodos) {
        if (this.$v.montoMaximo.$error) {
          this.montoMaximoValido = false;
          // if (!this.$v.montoMaximo.decimal || !this.$v.montoMaximo.minValue) {
          if (!this.$v.montoMaximo.decimal) {
            this.montoMaximoInvalidoMsj = 'El monto máximo debe ser un valor numérico positivo';
          }
        } else {
          this.montoMaximoValido = null;
          this.montoMaximoInvalidoMsj = '';
        }
      }

      if (campo == 'pjeFinanciacion' || validarTodos) {
        if (this.$v.pjeFinanciacion.$error) {
          this.pjeFinanciacionValido = false;
          if (!this.$v.pjeFinanciacion.decimal || !this.$v.pjeFinanciacion.minValue) {
            this.pjeFinanciacionInvalidoMsj = 'El porcentaje de financiación debe ser un valor numérico positivo';
          }
        } else {
          this.pjeFinanciacionValido = null;
          this.pjeFinanciacionInvalidoMsj = '';
        }
      }
    },
    calcularMontoMinimo() {
      this.montoMinimo = 0;

      if (this.escalas) {
        if (this.escalas.length != 0) {
          if (!(/true/i).test(this.limiteMaximoHabilitado)) {
            this.montoMinimo = Math.max(...this.escalas.map(escala => escala.montoMaximo)) + 1;
          } else {
            let escalaPrevia = this.escalas
              .slice()
              .sort((a, b) => b.montoMaximo - a.montoMaximo)
              .find(escala => escala.montoMaximo < this.montoMaximo);
            
            if (escalaPrevia) {
              this.montoMinimo = parseFloat(escalaPrevia.montoMaximo + 1);
            }
          }
        }
      }
    },
    save () {
      let save = true;

      this.calcularMontoMinimo();
      
      /* Antes de intentar registrar por primera vez, no validamos */
      this.noValidar = false;

      this.$v.$touch();

      if (this.$v.$anyError) {
        this.displayErrores();
      } else {
        if (save) {
          let escalaFinanciacion = {
            montoMinimo: this.montoMinimo,
            montoMaximo: (/true/i).test(this.limiteMaximoHabilitado)? this.montoMaximo : 0,
            pjeFinanciacion: this.pjeFinanciacion
          }

          this.$emit('updateEscalaFinanciacion', escalaFinanciacion);
        }
      } 
    },
    close() {
      this.$emit('close');
    },
  },
  watch: {
    'limiteMaximoHabilitado' : function(newVal, oldVal) {
      if ( newVal != oldVal) {
        this.calcularMontoMinimo();
      }
    },
  },
  validations: {
    montoMaximo: {
      decimal,
      // minValue: minValue(0.01),      
    },
    pjeFinanciacion: {
      decimal,
      minValue: minValue(0.01),      
    },
  },  
}
</script>

<style>
</style>
